/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React, { useCallback, useContext, useMemo } from 'react';
import { PropertyDropdown } from 'components/dropdowns/propertyDropdown';
import { WorkspaceContext } from '/views/workspace/workspaceContext';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';
import { selectDilDefinitionByName, selectPropertyListFromDilByNames } from 'srs-middleware';

/**
 * Selects a property from a list of filtered properties.
 *
 * @param cardIndex
 * @param propertyName
 * @param label
 * @param flags
 * @param types
 * @param endpointQuery
 * @param optionsKey
 * @param isNullable
 * @returns {JSX.Element}
 * @constructor
 */
export const EndpointPropertyArraySelector = ({
	cardIndex,
	propertyName,
	label,
	flags,
	types,
	endpointQuery,
	optionsKey = 'parameters',
	isNullable = false,
}) => {
	const {
		state: {
			explorer: { selectedDefinitionName },
		},
		dispatch,
	} = useContext(WorkspaceContext);

	const handleSelectionChange = useCallback(
		(newVal) => {
			const configuration = JSON.parse(JSON.stringify(endpointQuery));
			if (optionsKey === 'propertyList') {
				try {
					configuration.options[optionsKey].push(newVal.name);
				} catch (e) {}
			} else {
				configuration.options.parameters[propertyName] = [newVal?.name];
				if (!configuration.meta) configuration.meta = [];
				configuration.meta[label] = newVal?.name;
			}
			dispatch(WorkspaceActionCreator.options(cardIndex, configuration));
		},
		[cardIndex, dispatch, endpointQuery, label, optionsKey, propertyName]
	);

	const selectedDefinition = useMemo(() => {
		return selectDilDefinitionByName(selectedDefinitionName);
	}, [selectedDefinitionName]);

	const activeItem = useMemo(() => {
		let existingName = '';
		if (optionsKey === 'propertyList') {
			existingName = endpointQuery?.options?.propertyList?.[0];
		} else {
			existingName = endpointQuery?.options?.parameters?.[propertyName]?.[0];
		}

		if (!existingName) return null;

		// TODO: SRS-MIDDLEWARE should add a singular call
		return selectPropertyListFromDilByNames(selectedDefinitionName, [existingName])?.[0];
	}, [endpointQuery, optionsKey, propertyName, selectedDefinitionName]);

	return (
		<PropertyDropdown
			selectedDefinition={selectedDefinition}
			onSelectionChanged={handleSelectionChange}
			activeItem={activeItem}
			flags={flags}
			types={types}
			label={label}
			isNullable={isNullable}
		/>
	);
};
